import Notify from "./notify";
import { sendDeleteRequest, sendPatchRequest, sendPutRequest, sendPostRequest } from './apiv4helper';
import {tariffElements, validate} from './OCPITariffFieldsValidation'
import { getLanguages } from '../libs/languages';

const ENERGY = 'ENERGY';
const FLAT = 'FLAT';
const PARKING_TIME = 'PARKING_TIME';
const TIME = 'TIME';
let currentTariff;
let nameFieldsIds = [];
const i18n = require("i18next");
const priceComponentTypes = ['energy', 'flat', 'time'];

const drawTariff = (data, contractId, forEMSP = true) => {
    let modal = $(".show-tariff-modal");
    modal.modal('hide');
    let modalContent = modal.find('.modalContent').hide();
    let tariffBody = modal.find('.tariffBody');
    let tableBody = '';
    if (data.length) {
        currentTariff = data;
        for (let i = 0; i < data.length; i++) {
            tableBody += '<tr>';
            let tariff = data[i];
            let tariffName = '';
            let tariffURL = '';
            if (tariff.hasOwnProperty('tariff_alt_text') && tariff.tariff_alt_text.length) {
                tariffName = tariff.tariff_alt_text;
            }
            if (tariff.hasOwnProperty('tariff_alt_url') && tariff.tariff_alt_url.length) {
                tariffURL = tariff.tariff_alt_url;
            }
            tableBody += '<td>' + tariff.currency + '</td>';
            if (tariffName !== '') {
                tableBody += '<td class="single line"><div class="ui list">';
                $.each(tariffName, function (key, value) {
                    if (value.language === 'en') {
                        value.language = 'gb';
                    }
                    if (value.language === 'ka') {
                        value.language = 'ge';
                    }
                    tableBody += '<div class="item">' +
                        '<i class="' + value.language + ' flag"></i>' + value.text +
                        '</div>';
                });
                tableBody += '</div></td>';
            } else {
                tableBody += '<td>' + tariffName + '</td>';
            }
            tableBody += '<td><a href="' + tariffURL + '">' + tariffURL + '</a></td>';
            tableBody += '<td>';
            tableBody += getPriceDetails(tariff, forEMSP);
            tableBody += '</td>';
            tableBody += '<td>' + tariff.last_updated + '</td>';
            if (!forEMSP) {
                tableBody += '<td><div class="ui small button update-tariff" data-id="' + tariff.id + '" data-contract-id="' + contractId + '">' + i18n.t('Update') + '</div></td>';
                tableBody += '<td><div class="ui small button red delete-tariff" data-id="' + tariff.id + '" data-contract-id="' + contractId + '">' + i18n.t('Delete') + '</div></td>';
            }
            tableBody += '</tr>';
        }
        if (!forEMSP) {
            modal.find('.create-tariff').hide();
        }
        modalContent.show();
        modal.find('.header').text(i18n.t('roamingManagement.ocpi.active_tariff'));
        tariffBody.html(tableBody);
    } else {
        tariffBody.empty();
        modalContent.hide();
        modal.find('.header').text(i18n.t('roamingManagement.ocpi.no_active_tariff'));
        if (!forEMSP) {
            $('.create-tariff-btn').data('contract-id', contractId);
            $('.create-tariff-btn').show();
        }
    }
    modal.modal('show');
    undim();
};

const showEmpTariffModal = (contractId) => {
    let modal = $(".manage-emp-tariff-modal");
    modal.modal('hide');
    resetEmpTariffForms();
    $('#empTariffContractId').val(contractId);
    $('#isEmpTariffExisting').val('false');
    modal.modal('show');
    undim();
};

const fillAndShowEmpTariffModal = (elements, contractId) => {
    let modal = $(".manage-emp-tariff-modal");
    modal.modal('hide');
    resetEmpTariffForms();
    $('#empTariffContractId').val(contractId);
    $('#isEmpTariffExisting').val('true');
    for (let j = 0; j < elements.length; j++) {
        const priceComponents = elements[j].price_components;
        for (let k = 0; k < priceComponents.length; k++) {
            const item = priceComponents[k];
            const priceDetails = $('.manage-emp-tariff-modal').find('.createEmpTariffForm');
            priceDetails.find(`#ac_${item.type.toLowerCase()}`).val(item.price);
            priceDetails.find(`#dc_${item.type.toLowerCase()}`).val(item.dc_price);
            if (item.type === 'TIME') {
                priceDetails.find(`#ac_free_minutes`).val(item.ac_free_minutes);
                priceDetails.find(`#dc_free_minutes`).val(item.dc_free_minutes);
            }
        }
    }
    fillVatAndNetPricesForEmpTariff();
    modal.modal('show');
    undim();
};

const fillVatAndNetPricesForEmpTariff = () => {
    const targetIds = ['ac_time', 'ac_energy', 'ac_flat', 'dc_time', 'dc_energy', 'dc_flat'];
    targetIds.forEach((fieldId) => {
        calculateVatAndNetPrice(fieldId, $('.emp_tariff_' + fieldId).val());
    });
}

const getPriceDetails = (tariff, forEMSP) => {
    let elements = tariff.elements;
    let tableData = '<div class="ui list">';
    for (let j = 0; j < elements.length; j++) {
        const priceComponents = elements[j].price_components;
        let restrictions = false;
        if (elements[j].hasOwnProperty('restrictions')) {
            restrictions = elements[j].restrictions;
        }
        for (let k = 0; k < priceComponents.length; k++) {
            let item = priceComponents[k];
            let type = item.type;
            let restrictionTxt = restrictions ? '<span style="color: red;"> Price is valid:<br>' + getRestrictions(restrictions) + '</span>' : '';
            switch(type) {
                case ENERGY:
                    let energyPrice = 'Charge price based on energy is <b>' + item.price + ' ' + tariff.currency + ' per kWh</b><br>' + restrictionTxt;
                    if (!forEMSP) {
                        energyPrice = 'Energy price for <b>AC is ' + item.price + ' and for DC is ' + item.dc_price + ' ' + tariff.currency + ' per kWh.</b>';
                    }
                    tableData += '<div class="item">' +
                        '<i class="car icon"></i>' +
                        '<div class="content">'+
                        energyPrice +
                        '</div>' +
                        '</div>';
                    break;
                case FLAT:
                    let flatPrice = 'Initial charge price is <b>'+item.price + ' ' + tariff.currency + '.</b><br>';
                    if (!forEMSP) {
                        flatPrice = 'Session fee for <b>AC is ' + item.price + ' and for DC is ' + item.dc_price + ' ' + tariff.currency + '.</b>';
                    }
                    tableData += '<div class="item">' +
                        '<i class="plug icon"></i>' +
                        '<div class="content">' +
                        flatPrice +
                        '</div>' +
                        '</div>';
                    break;
                case PARKING_TIME:
                    let parkingPrice = 'Parking price is <b>'+item.price + ' ' + tariff.currency + ' per hour</b><br>' + restrictionTxt;
                    tableData += '<div class="item">' +
                        '<i class="clock icon"></i>' +
                        '<div class="content">' +
                        parkingPrice +
                        '</div>' +
                        '</div>';
                    break;
                case TIME:
                    let timePrice = 'Charge price based on time is <b>' + item.price + ' ' + tariff.currency + ' per hour</b><br>' + restrictionTxt;
                    if (!forEMSP) {
                        timePrice = 'Hour price for <b>AC is ' + item.price + ' and DC is ' + item.dc_price + ' ' + tariff.currency + ' per hour.</b>';
                    }
                    tableData += '<div class="item">' +
                        '<i class="hourglass half icon"></i>' +
                        '<div class="content">' +
                        timePrice +
                        '</div>' +
                        '</div>';
                    break;
                default:
                    continue;
            }
        }
    }
    tableData += '</div>';
    return tableData;
};

const getRestrictions = (restrictions) => {
    let restrictionTxt = '<ul>';
    let startTimeAndTime = false;
    let startDateAndDate = false;
    let timeRestriction = false;
    $.each(restrictions, function (key, value) {
        if ('start_time' in restrictions && 'end_time' in restrictions) {
            if (!timeRestriction) {
                restrictionTxt += '<li>Between ' + restrictions.start_time + ' and ' + restrictions.end_time + '</li>';
                startTimeAndTime = true;
                timeRestriction = true;
            }
        }
        if ('start_date' in restrictions && 'end_date' in restrictions) {
            if (!timeRestriction) {
                restrictionTxt += '<li>Between ' + restrictions.start_date + ' and ' + restrictions.end_date + '</li>';
                startDateAndDate = true;
                timeRestriction = true;
            }
        }
        switch (key) {
            case 'start_time':
                if (!startTimeAndTime) {
                    restrictionTxt += '<li>After ' + value + '</li>';
                }
                break;
            case 'end_time':
                if (!startTimeAndTime) {
                    restrictionTxt += '<li>Before ' + value + '</li>';
                }
                break;
            case 'start_date':
                if (!startDateAndDate) {
                    restrictionTxt += '<li>After ' + value + '</li>';
                }
                break;
            case 'end_date':
                if (!startDateAndDate) {
                    restrictionTxt += '<li>Before ' + value + '</li>';
                }
                break;
            case 'min_kwh':
                restrictionTxt += '<li>When minimum ' +  value + ' kWh' + ' is used energy</li>';
                break;
            case 'max_kwh':
                restrictionTxt += '<li>When maximum ' +  value + ' kWh' + ' is used energy</li>';
                break;
            case 'min_power':
                restrictionTxt += '<li>When minimum ' +  value + ' kW charging speed is used</li>';
                break;
            case 'max_power':
                restrictionTxt += '<li>When maximum ' +  value + ' kW charging speed is used</li>';
                break;
            case 'min_duration':
                restrictionTxt += '<li>When minimum charging duration is ' +  value / 3600 + ' hours</li>';
                break;
            case 'max_duration':
                restrictionTxt += '<li>When maximum charging duration is ' +  value / 3600 + ' hours</li>';
                break;
            case 'day_of_week':
                let days = '';
                for (let i = 0; i < value.length; i++) {
                    if (i !== value.length - 1) {
                        days += value[i] + ', ';
                    } else {
                        days += value[i];
                    }
                }
                restrictionTxt += '<li>Only on ' + days + '</li>';
                break;
        }
    });
    restrictionTxt += '</ul>';
    return restrictionTxt;
};

const showEditTariffForm = (tariffId, contractId, sellerId, currency) => {
    resetForms();
    const tariffData = currentTariff;
    let editForm = $(".editTariff");
    $("#tariff_currency").val(currency);
    $(".updateTariffId").val(tariffId);
    $(".updateContractId").val(contractId);
    $(".updateSellerId").val(sellerId);

    $(".priceDetails").find('.checkbox').checkbox('uncheck');
    $(".details").hide();
    let tariffNames = [];
    for (let i = 0; i < tariffData.length; i++) {
        const tariff = tariffData[i];
        const elements = tariff.elements;
        if (tariff.id === tariffId) {
            let tariffName = '';
            let tariffURL = '';
            if (tariff.hasOwnProperty('tariff_alt_text') && tariff.tariff_alt_text.length) {
                tariffName = tariff.tariff_alt_text;
            }

            if (tariff.hasOwnProperty('tariff_alt_url') && tariff.tariff_alt_url.length) {
                tariffURL = tariff.tariff_alt_url;
            }
            editForm.form('set values', {
                tariff_alt_url   : tariffURL
            });
            let tariffNameHTML = '';
            if (tariffName !== '') {
                let i = 1;
                $.each(tariffName, function (key, value) {
                    tariffNameHTML += generateNameField(i, value.text);
                    tariffNames[i] = value.language;
                    nameFieldsIds.push(i);
                    i++;
                });
            } else {
                tariffNames[1] = $('#country_code').val().toLowerCase();
                nameFieldsIds.push(1);
                tariffNameHTML += generateNameField(1);
            }
            $(".tariffName").html(tariffNameHTML);
            for (let j = 0; j < elements.length; j++) {
                const priceComponents = elements[j].price_components;
                for (let k = 0; k < priceComponents.length; k++) {
                    const item = priceComponents[k];
                    const priceDetails = $('.update-tariff-modal').find('.priceDetails');
                    priceDetails.find(`#ac_${item.type.toLowerCase()}`).val(item.price);
                    priceDetails.find(`#dc_${item.type.toLowerCase()}`).val(item.dc_price);
                }
            }
        }
    }
    for (let j = 1; j <= tariffNames.length; j++) {
        if (tariffNames[j] === 'gb') {
            tariffNames[j] = 'en';
        }
        if (tariffNames[j] === 'ge') {
            tariffNames[j] = 'ka';
        }
        $('.language-list-'+j).dropdown('set selected', tariffNames[j]);
    }
    $(".update-tariff-modal").modal('show');
    const $popup = $('.ui.infopopup');
    $popup.popup();
};

const deleteTariff = (id, contractId, sellerId) => {
    modalDim();
    sendDeleteRequest('/admin/roaming/cpo/tariff/' + id + '/' + contractId + '/' + sellerId)
    .done(() => {
        $(".show-tariff-modal").modal('hide');
        modalUndim();
        Notify.success(i18n.t('roamingManagement.ocpi.tariff_deleted'));
    })
    .fail(() => {
        Notify.error(i18n.t('roamingManagement.ocpi.tariff_delete_failed'));
        modalUndim();
    });
};

const updateTariff = () => {
    updateTariffModalDim();
    const form = $(".editTariff");
    const formIsValid = validate(form, nameFieldsIds);
    if (!formIsValid) {
        updateTariffModalUndim();
        return;
    }
    let data = prepareTariffDataForPost(form.form('get values'));
    if (data['elements'] === undefined || data['elements'].length === 0) {
        alert(i18n.t('roamingManagement.ocpi.price_type_required'));
        return;
    }
    let tariffId = $(".updateTariffId").val();
    let contractId = $(".updateContractId").val();
    let sellerId = $(".updateSellerId").val();
    let modal = $(".update-tariff-modal");
    sendPatchRequest('/admin/roaming/cpo/tariff/' + tariffId + '/' + contractId + '/' + sellerId, data)
    .done(() => {
        updateTariffModalUndim();
        modal.modal('hide');
        $(".show-tariff-modal").modal('hide');
        Notify.success(i18n.t('roamingManagement.ocpi.tariff_updated'));
    })
    .fail(() => {
        Notify.error(i18n.t('roamingManagement.ocpi.tariff_update_failed'));
        updateTariffModalUndim();
    });
};

const calculateVatAndNetPrice = (targetId, grossPrice) => {
    if (!grossPrice && grossPrice.trim() == '') {
        $('#' + targetId + '_vat').html('');
        $('#' + targetId + '_net').html('');
        return;
    }
    let taxPercentage = $('#emp_tariff_vat').val();
    taxPercentage = parseFloat(taxPercentage);
    const vatRate = taxPercentage * 100;
    const currency = $('#emp_tariff_currency').val();
    grossPrice = parseFloat(grossPrice);
    let vatPrice = grossPrice / (100 + vatRate) * vatRate;
    vatPrice = Math.round(vatPrice * 100) / 100;
    let netPrice = (grossPrice - vatPrice).toFixed(2);
    $('#' + targetId + '_net').html(netPrice + ' ' + currency);
    $('#' + targetId + '_vat').html(vatPrice.toFixed(2) + ' ' + currency);
}

const generateNameField = (i = getMaxNameFieldId, value = 'tariff name') => {
    let html = '';
    html += '<div class="ui grid" data-id="' + i + '">';
    html += generateLanguageList(i);
    html += '<div class="six wide column"><label>' + i18n.t('roamingManagement.ocpi.text') + '</label><input type="text" name="tariffName' + i + '[text]" placeholder="https://tariff.example.com" value="'+ value +'"></div>';
    html += '<div class="two wide column"><button class="ui labeled icon button remove-name-field" style="margin-top:20px;" data-id="' + i + '"><i class="trash icon"></i>' + i18n.t('Delete') + '</button></div>';
    html += '</div>';
    return html;
};

const generateLanguageList = (index) => {
    const languages = getLanguages();
    let html = '<div class="six wide column">' +
        '<label>Language</label>' +
        '<select name="tariffName' + index + '[language]" class="ui fluid search dropdown language-list-' + index + '">';
    $.each(languages, function (key, value) {
        html += '<option class="item" value="' + key + '"><i class="' + key + ' flag"></i>' + value.name + '</option>';
    });
    html += '</select></div>';
    return html;
};

const appendNewNameFieldToForm = () => {
    const id = getMaxNameFieldId() + 1;
    const html = generateNameField(id);
    $(".tariffName").append(html);
    $(".language-list-"+id).dropdown();
    nameFieldsIds.push(id);
};

const prependNameFieldFromForm = (element) => {
    element.parent().parent().remove();
    for(let i = 0; i < nameFieldsIds.length; i++){
        if (nameFieldsIds[i] === element.data('id')) {
            nameFieldsIds.splice(i, 1);
        }
    }
};

const getMaxNameFieldId = () => {
    if (nameFieldsIds === undefined || nameFieldsIds.length === 0) {
        return 1;
    }
    return Math.max.apply(Math, nameFieldsIds);
};

const prepareTariffDataForPost = (formData) => {
    let tariff_alt_text = [];
    for (let i = 0; i < nameFieldsIds.length; i++) {
        const langKeyName = 'tariffName' + nameFieldsIds[i] + '[language]';
        const textKeyName = 'tariffName' + nameFieldsIds[i] + '[text]';
        tariff_alt_text[i] = {
            language: formData[langKeyName],
            text: formData[textKeyName]
        };
    }
    return {
        currency: formData.currency,
        tariff_alt_text: tariff_alt_text,
        tariff_alt_url: formData.tariff_alt_url,
        elements: tariffElements
    };
};

const createTariff = () => {
    updateTariffModalDim();
    const form = $(".createTariffForm");
    const formIsValid = validate(form, nameFieldsIds);
    if (!formIsValid) {
        updateTariffModalUndim();
        return;
    }
    let data = prepareTariffDataForPost(form.form('get values'));
    const modal = $(".create-tariff-modal");
    const contractId = $(".createContractId").val();
    const sellerId = $(".createSellerId").val();
    sendPutRequest('/admin/roaming/cpo/tariff/' + contractId + '/' + sellerId, data)
    .done((data) => {
        updateTariffModalUndim();
        modal.modal('hide');
        $(".show-tariff-modal").find(".create-tariff-btn").hide();
        const arrayData = [];
        arrayData[0] = data;
        drawTariff(arrayData, contractId, false);
        Notify.success(i18n.t('roamingManagement.ocpi.tariff_created'));
    })
    .fail(() => {
        Notify.error(i18n.t('roamingManagement.ocpi.tariff_create_failed'));
        updateTariffModalUndim();
    });
};

const createOrUpdateEmpTariff = () => {
    const contractId = $('#empTariffContractId').val();
    updateEmpTariffModalDim();
    const form = $(".createEmpTariffForm");
    const formIsValid = validate(form, nameFieldsIds, true);
    if (!formIsValid) {
        updateEmpTariffModalUndim();
        return;
    }
    let data = prepareTariffDataForPost(form.form('get values'));

    const isEmpTariffExisting = $('#isEmpTariffExisting').val() == 'true';
    const empTariffUpdateOrCreateRequest = isEmpTariffExisting ? sendPatchRequest : sendPostRequest;

    empTariffUpdateOrCreateRequest('/admin/roaming/emp/tariff/' + contractId, data)
        .done((data) => {
            updateEmpTariffModalUndim();
            $('#isEmpTariffExisting').val('true');
            Notify.success('EMP Tariff has been successfully saved.');
        })
        .fail(() => {
            Notify.error('Failed to save EMP tariff!');
            updateEmpTariffModalUndim();
        });
};

const dim = () => $('body').find('.main-dimmer').addClass('active');

const undim = () => $('body').find('.main-dimmer').removeClass('active');

const modalDim = () => $('body').find('.modal-dimmer').addClass('active');

const modalUndim = () => $('body').find('.modal-dimmer').removeClass('active');

const updateTariffModalDim = () => $('body').find('.update-tariff-dimmer').addClass('active');

const updateTariffModalUndim = () => $('body').find('.update-tariff-dimmer').removeClass('active');

const updateEmpTariffModalDim = () => $('body').find('.update-emp-tariff-dimmer').addClass('active');

const updateEmpTariffModalUndim = () => $('body').find('.update-emp-tariff-dimmer').removeClass('active');

const resetForms = () => {
    nameFieldsIds = [];
    const updateForm = $(".update-tariff-modal");
    const createForm = $(".create-tariff-modal");
    updateForm.find('.tariffName').empty();
    createForm.find('.tariffName').empty();
    priceComponentTypes.forEach(function (value) {
        updateForm.find('.editTariff').form('reset');
        createForm.find('.createTariffForm').form('reset');
        updateForm.find(`#ac_${value}`).val('');
        updateForm.find(`#dc_${value}`).val('');
        createForm.find(`#ac_${value}`).val('');
        createForm.find(`#dc_${value}`).val('');
    });
};

const resetEmpTariffForms = () => {
    const updateForm = $(".manage-emp-tariff-modal");
    updateForm.find('.createEmpTariffForm').form('reset');
    updateForm.find('.emp_tariff_ac_free_minutes').val('');
    updateForm.find('.emp_tariff_dc_free_minutes').val('');
    priceComponentTypes.forEach(function (value) {
        updateForm.find(`#ac_${value}`).val('');
        updateForm.find(`#dc_${value}`).val('');
        updateForm.find(`#ac_${value}_vat`).html('');
        updateForm.find(`#dc_${value}_vat`).html('');
        updateForm.find(`#ac_${value}_net`).html('');
        updateForm.find(`#dc_${value}_net`).html('');
    });
};

export {
    appendNewNameFieldToForm,
    calculateVatAndNetPrice,
    createTariff,
    createOrUpdateEmpTariff,
    deleteTariff,
    dim,
    drawTariff,
    fillAndShowEmpTariffModal,
    modalDim,
    modalUndim,
    nameFieldsIds,
    prependNameFieldFromForm,
    priceComponentTypes,
    resetForms,
    showEditTariffForm,
    showEmpTariffModal,
    undim,
    updateTariff,
    updateTariffModalDim,
    updateTariffModalUndim,
    getPriceDetails,
    generateNameField,
};
